// SEO Utility Functions for Dynamic Meta Tags

export const updateMetaTags = ({ title, description, keywords, image, url }) => {
    // Update title
    if (title) {
        document.title = title;
        updateMetaTag('og:title', title);
        updateMetaTag('twitter:title', title);
    }

    // Update description
    if (description) {
        updateMetaTag('description', description);
        updateMetaTag('og:description', description);
        updateMetaTag('twitter:description', description);
    }

    // Update keywords
    if (keywords) {
        updateMetaTag('keywords', keywords);
    }

    // Update image
    if (image) {
        updateMetaTag('og:image', image);
        updateMetaTag('twitter:image', image);
    }

    // Update URL
    if (url) {
        updateMetaTag('og:url', url);
        updateMetaTag('twitter:url', url);
        updateLinkTag('canonical', url);
    }
};

const updateMetaTag = (name, content) => {
    // Try property first (for og: and twitter:)
    let element = document.querySelector(`meta[property="${name}"]`);

    // If not found, try name attribute
    if (!element) {
        element = document.querySelector(`meta[name="${name}"]`);
    }

    if (element) {
        element.setAttribute('content', content);
    } else {
        // Create new meta tag if it doesn't exist
        const meta = document.createElement('meta');
        if (name.startsWith('og:') || name.startsWith('twitter:')) {
            meta.setAttribute('property', name);
        } else {
            meta.setAttribute('name', name);
        }
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
    }
};

const updateLinkTag = (rel, href) => {
    let element = document.querySelector(`link[rel="${rel}"]`);

    if (element) {
        element.setAttribute('href', href);
    } else {
        const link = document.createElement('link');
        link.setAttribute('rel', rel);
        link.setAttribute('href', href);
        document.head.appendChild(link);
    }
};

// Product Schema Generator
export const generateProductSchema = (product) => {
    return {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": product.name,
        "description": product.description || `Premium quality ${product.name}`,
        "image": product.image,
        "brand": {
            "@type": "Brand",
            "name": "Grainly"
        },
        "offers": {
            "@type": "Offer",
            "url": `https://www.grainly.in.net/product/${product._id}`,
            "priceCurrency": "INR",
            "price": product.price,
            "availability": product.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
            "seller": {
                "@type": "Organization",
                "name": "Grainly"
            }
        },
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": Math.floor(Math.random() * 500) + 100
        }
    };
};

// Inject Schema into page
export const injectSchema = (schema) => {
    // Remove existing product schema if any
    const existingSchema = document.querySelector('script[data-schema="product"]');
    if (existingSchema) {
        existingSchema.remove();
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'product');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
};

// Breadcrumb Schema Generator
export const generateBreadcrumbSchema = (items) => {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": item.url
        }))
    };
};
